import React, { useEffect, useRef } from 'react';
import Sheet from 'react-modal-sheet';

import { useAllSelector } from '../../services/selectors/allSelector';
import { useLocation } from 'react-router-dom';

import {
	finalMissedRoute,
	todayMissedRoute,
	todayPendingRoute
} from '../../storage';

import { useAuthSelector } from '../../services/selectors/authSelector';

import * as Icons from '../../assets/svg/icons';
import * as routeNames from '../../routes/routeName';
import * as Hooks from '../../hooks';

export const RouteConfirmation = ({ showConfirmationModal, setShowConfirmationModal }) => {

	const navigate = Hooks.useCustomNavigate();
	const location = useLocation()

	const { driverSelectedPharmacy } = useAuthSelector()

	return (
		<React.Fragment>
			<Sheet isOpen={showConfirmationModal} onClose={() => setShowConfirmationModal(false)}>
				<Sheet.Container>
					<Sheet.Content>

						<div className="flex items-center justify-between p-2 px-4 md:p-3 border-b border-dashed rounded-t">
							<h3 className="text-sm font-bold text-gray-900">
								{driverSelectedPharmacy?.pharmacies?.name?.toUpperCase()}
							</h3>

							<button type="button"
								onClick={() => setShowConfirmationModal(false)}
								className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 
											ms-auto inline-flex justify-center items-center"
								data-modal-hide="bottom-right-modal">
								<Icons.CloseModelIcon />
								<span className="sr-only">Close modal</span>
							</button>

						</div>
						<div className="max-w-md mx-auto p-6 bg-white  rounded-md">
							<form>

								<div className="mb-4">
									<label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900">
										Are you sure you want to exit from this route?
									</label>
								</div>

								<div className="flex justify-center items-center gap-2">

									{location.pathname.startsWith(routeNames.Missed_Route) ?
										<button onClick={() => {
											return localStorage.removeItem(todayMissedRoute),
												navigate(`${routeNames.DASHBOARD_PHARMACY}`)
										}} type="button" className="bg-blue-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
											Yes
										</button> :
										location.pathname.startsWith(routeNames.driver_today_pending) ?
											<button onClick={() => {
												return localStorage.removeItem(todayPendingRoute),
													navigate(`${routeNames.DASHBOARD_PHARMACY}`)
											}} type="button" className="bg-blue-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
												Yes
											</button> :
											location.pathname.startsWith(routeNames.driver_Missed_Route) ?
												<button onClick={() => {
													return localStorage.removeItem(finalMissedRoute),
														navigate(`${routeNames.DASHBOARD_PHARMACY}`)
												}} type="button" className="bg-blue-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
													Yes
												</button> :

												<button onClick={() => navigate(`${routeNames.DASHBOARD_PHARMACY}`)} type="button" className="bg-blue-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
													Yes
												</button>}

									<button onClick={() => setShowConfirmationModal(false)} type="button" className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50">
										Cancel
									</button>

								</div>
							</form>
						</div>

					</Sheet.Content>
				</Sheet.Container>
				<Sheet.Backdrop />
			</Sheet>
		</React.Fragment>
	)
}

export const MissedDeliveryConfirmation = ({ showConfirmationModal, setShowConfirmationModal, pharmacyId, handleMissedDelivery, missedData }) => {

	const { updateDeliveryListResponse } = useAllSelector()

	return (
		<React.Fragment>
			<Sheet isOpen={showConfirmationModal} onClose={() => setShowConfirmationModal(false)}>
				<Sheet.Container>
					<Sheet.Content >

						<div className="flex items-center justify-between p-2 px-4 md:p-3 border-b border-dashed rounded-t">
							<h3 className="text-sm font-bold text-gray-900">
								{missedData?.first_name} {missedData?.last_name}
							</h3>
							<button type="button"
								onClick={() => setShowConfirmationModal(false)}
								className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
								data-modal-hide="bottom-right-modal">
								<Icons.CloseModelIcon />
								<span className="sr-only">Close modal</span>
							</button>
						</div>
						<div className="max-w-md mx-auto p-6 bg-white  rounded-md">
							<form>
								<div className="mb-4">
									<label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900">
										Are you sure you missed for this delivery ?
									</label>
								</div>

								<div className="flex justify-center items-center gap-2">
									<button onClick={handleMissedDelivery} type="button" className="bg-red-600 hover:bg-red-600 text-white font-semibold px-4 py-2 rounded focus:outline-none 
									focus:ring-2 focus:ring-red-500 focus:ring-opacity-50">
										{/* {updateDeliveryListResponse?.loading ? 'Processing...' : 'Yes'} */}
										Yes
									</button>
									<button onClick={() => setShowConfirmationModal(false)} type="button" className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50">
										Cancel
									</button>
								</div>
							</form>
						</div>

					</Sheet.Content>
				</Sheet.Container>
				<Sheet.Backdrop />
			</Sheet>
		</React.Fragment>
	)
}

function blurFocusedInput() {
	const el = document.activeElement;
	if (el?.blur && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')) el.blur();
}

export const PharmacistConfirmationModal = ({ 
	showModal, 
	setShowModal, 
	pharmacistName, 
	onConfirm, 
	onCancel 
}) => {
	const lastConfirmRef = useRef(0);

	// Blur when modal opens so keyboard dismisses on iOS
	useEffect(() => {
		if (showModal) {
			blurFocusedInput();
			const id = requestAnimationFrame(() => blurFocusedInput());
			return () => cancelAnimationFrame(id);
		}
	}, [showModal]);

	const handleClose = () => {
		setShowModal(false);
		if (onCancel) onCancel();
	};

	const handleConfirm = () => {
		blurFocusedInput();
		const now = Date.now();
		if (now - lastConfirmRef.current < 300) return;
		lastConfirmRef.current = now;
		onConfirm?.();
	};

	if (!showModal) return null;

	return (
		<div
			className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
			role="dialog"
			aria-modal="true"
			aria-labelledby="pharmacist-confirmation-title"
		>
			{/* Backdrop - faded/dimmed background */}
			<div
				className="absolute inset-0 z-[1]"
				style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
				onClick={handleClose}
				onKeyDown={(e) => e.key === 'Escape' && handleClose()}
				aria-hidden="true"
			/>
			{/* Modal content */}
			<div className="relative z-[2] bg-white rounded-lg max-w-md w-full border border-gray-200 overflow-hidden" style={{ boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05)' }}>
				<div className="flex items-center justify-between p-2 px-4 md:p-3 border-b border-dashed rounded-t">
					<h3 id="pharmacist-confirmation-title" className="text-sm font-bold text-gray-900">
						Confirm Pharmacist
					</h3>
					<button 
						type="button"
						onClick={handleClose}
						className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
						data-modal-hide="pharmacist-confirmation-modal"
						aria-label="Close modal"
					>
						<Icons.CloseModelIcon />
					</button>
				</div>
				<div className="p-6">
					<div className="mb-4">
						<label className="block mb-2 text-base font-medium text-gray-900">
							You are signing as <span className="font-bold text-blue-600">{pharmacistName?.toUpperCase()}</span>
						</label>
					</div>
					<div className="flex justify-center items-center gap-2">
						<button 
							type="button"
							onClick={handleConfirm}
							onTouchEnd={(e) => { e.preventDefault(); handleConfirm(); }}
							className="bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-2 rounded focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
						>
							OK
						</button>
						<button 
							type="button"
							onClick={handleClose}
							className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}